import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth"; // Ligne ajoutée
import { getFunctions } from "firebase/functions"; // Ligne ajoutée

// TODO: Remplacez par votre propre objet de configuration Firebase !
const firebaseConfig = {
  apiKey: "AIzaSyANXZ53jFdcRn8ly-8cadjeM5Od6lGGEr8",
  authDomain: "mapit17-93fd1.firebaseapp.com",
  projectId: "mapit17-93fd1",
  storageBucket: "mapit17-93fd1.firebasestorage.app",
  messagingSenderId: "567246676716",
  appId: "1:567246676716:web:bb132aca3bf295dcf8bbc9"
};

// Initialiser Firebase
const app = initializeApp(firebaseConfig);

// Initialiser Firestore et l'exporter pour l'utiliser ailleurs
export const db = getFirestore(app);
export const auth = getAuth(app); // <-- EXPORT IMPORTANT
export const functions = getFunctions(app, 'europe-west1'); // On pointe vers l'Europe !